import { Component, Input } from '@angular/core';

import { ContactFallback } from '../footer.component.selectors';

@Component({
    selector: 'app-concierge',
    templateUrl: './concierge.component.html',
    styleUrls: ['./concierge.component.scss'],
    standalone: false,
})
export class ConciergeComponent {
    @Input() fallback: ContactFallback;
}
